import { ValueOf } from "src/types.d"

export const AttachmentFileType = Object.freeze({
  Image: "Image",
  Other: "Other",
} as const)

export type AttachmentFileType = ValueOf<typeof AttachmentFileType>
